import React, {Component} from 'react';
import {inject, observer} from "mobx-react/index";
import PopupCloseImage from '../../../assets/images/popup-close.png';

@inject("store")
@observer
export default class PopupCloseIcone extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <img src={PopupCloseImage} alt="popup-close" className={`popup-close-icone ${this.props.className || ""}`}/>;
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/PopupCloseIcone.js